import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef } from "react";
import { cn } from "../cn.ts";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-heading font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-rose focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98]",
  {
    variants: {
      variant: {
        primary: "bg-[var(--brand-ink)] text-[var(--brand-paper)] hover:opacity-90",
        secondary:
          "bg-[var(--brand-pink-soft)] text-[var(--brand-ink)] hover:bg-[var(--brand-pink)]",
        ghost: "bg-transparent text-[var(--brand-ink)] hover:bg-[var(--brand-pink-soft)]",
        outline:
          "border border-[var(--brand-border)] bg-transparent text-[var(--brand-ink)] hover:bg-[var(--brand-pink-soft)]",
        rose: "bg-[var(--brand-rose)] text-white hover:opacity-90",
      },
      size: {
        sm: "h-9 px-4 text-sm",
        md: "h-11 px-6 text-sm",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, ...rest },
  ref,
) {
  return (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...rest} />
  );
});

export { buttonVariants };
